import './ActionMenu-5fe972e2.css';

var styles = {"ActionMenuContainer":"prc-ActionMenu-ActionMenuContainer-XdFHv"};

export { styles as default };
